module.exports = __webpack_public_path__ + "068d5031ee3d2333bd54be5df73079e5.png";